const EditIcon = (props: any = {}) => {
    return (
        <svg width="16" height="16" {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.66003 1.85156H5.16736C3.11736 1.85156 1.83203 3.3029 1.83203 5.35756V10.9002C1.83203 12.9549 3.11136 14.4062 5.16736 14.4062H11.05C13.1067 14.4062 14.386 12.9549 14.386 10.9002V8.2149" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
            <path fillRule="evenodd" clipRule="evenodd" d="M5.88248 7.27513L10.8645 2.29313C11.4852 1.67312 12.4912 1.67312 13.1118 2.29313L13.9232 3.10446C14.5438 3.72513 14.5438 4.73179 13.9232 5.35179L8.91715 10.3578C8.64582 10.6291 8.27782 10.7818 7.89382 10.7818H5.39648L5.45915 8.26179C5.46848 7.89113 5.61982 7.53779 5.88248 7.27513Z" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.1074 3.0625L13.1514 6.1065" stroke="#0069AD" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default EditIcon